
import React from 'react';

interface IProps {
  style?: any;
  
}

export const CircleIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="90" height="87" viewBox="0 0 90 87" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="45" cy="43.5" rx="45" ry="43.5" fill="#dee2eb"/>
    </svg>
    
  )
}
